export default __webpack_public_path__ + "static/media/tooltip-ubigeo.3299d169.png";